import { render, staticRenderFns } from "./PlatformSalesOrder.vue?vue&type=template&id=0ded9f99&scoped=true"
import script from "./PlatformSalesOrder.vue?vue&type=script&lang=ts"
export * from "./PlatformSalesOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded9f99",
  null
  
)

export default component.exports